@import '../../globals/variables';
/**
 * THEME JSON CONFIG CSS VARS
 * The following default component scss variables can be overwritten via theme configuration per brand.
 * If you need to add new one, please make sure to set a default value.
 * JSON Definition for Component with name "Example": testCssVar: "20px"
 * Resulting CSS var: $example-test-css-var: 20px;
 */

$tooltip-default-shadow: none !default;
/* END THEME JSON CONFIG CSS VARS ******************************************************* */

:host {
  position: fixed;
  left: 0;
  top: 0;
  width: max-content;
  display: block;
  box-sizing: border-box;
  inline-size: max-content;
  visibility: hidden !important;
  opacity: 0;
  z-index: $mainNavigationZIndex - 2; // Has to be smaller than navigation as otherwise it's going to overlap the flyout as well.
  pointer-events: none;
  font-family: $font-family-regular; // ENVIAM
  font-size: $copy-font-size;
  font-weight: $copy-font-weight;
  line-height: $copy-line-height;
  box-shadow: $tooltip-default-shadow;
  //@include slotted-margins('*:not([slot])'); // ENVIAM

  * {
    width: fit-content;
  }
}

:host([visibility='onHover']) {
  z-index: $mainNavigationZIndex - 1;
}

:host(.#{$prefix}apply-transition) {
  transition-property: visibility, opacity;
  transition-duration: 200ms;
  transition-timing-function: ease-in-out;

  .#{$prefix}wrapper {
    .#{$prefix}arrow {
      transition-property: left, right;
      transition-duration: 200ms;
      transition-timing-function: ease-in-out;
    }
  }
}

:host(.#{$prefix}visible) {
  visibility: visible !important;
  opacity: 1;
  pointer-events: all;
}

.#{$prefix}wrapper {
  position: relative;
  max-width: 360px;
  padding: 24px;
  color: v(innerContentColor);
  background: v(backgroundColor);
  box-sizing: border-box;

  &.#{$prefix}small-size {
    padding: 7px 12px;
  }

  @include for-size(phone) {
    max-width: 288px;
    padding: 16px;
  }

  .#{$prefix}inner {
    position: relative;
    display: flex;
    flex-direction: column;

    &.#{$prefix}alignment-left {
      align-items: flex-start;
      text-align: left;
    }

    &.#{$prefix}alignment-center {
      align-items: center;
      text-align: center;
    }

    &.#{$prefix}alignment-right {
      align-items: flex-end;
      text-align: right;
    }
  }

  &.#{$prefix}visible {
    .#{$prefix}arrow {
      position: absolute;
      width: 8px;
      height: 8px;
      background: v(backgroundColor);
      visibility: hidden;
    }

    .#{$prefix}arrow::before {
      content: '';
      position: absolute;
      left: 0;
      top: 0;
      width: 8px;
      height: 8px;
      background: inherit;
      visibility: visible;
      transform: rotate(45deg);
    }
  }
}

::slotted(envc-eon-ui-link) {
  --contentColor: var(--innerContentColor) !important;
  --contentHoverColor: var(--innerContentColor) !important;
}

::slotted(envc-eon-ui-headline) {
  color: v(innerContentColor);
}

::slotted(*) {
  //@include eon-typography(copy); // ENVIAM
  color: v(innerContentColor);
}

::slotted(*:not([slot])) {
  margin-bottom: 16px !important;
}

::slotted(*:not([slot]):last-child) {
  margin-bottom: 0 !important;
}

// ENVIAM
$tooltip-border: none !default;
:host {
  border-radius: 12px;
  border: $tooltip-border;
}
.#{$prefix}wrapper {
  border-radius: 12px;
  padding: 12px 16px;
  .#{$prefix}arrow {
    display: none;
  }

  &.#{$prefix}small-size {
    envc-eon-ui-button {
      top: 7px;
      right: 12px;
    }
  }
}
